import {Component, ElementRef, HostBinding, Input, OnChanges, Renderer2} from '@angular/core';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {BaseComponent} from '@vdw/angular-component-library';
import {isNil} from 'lodash-es';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-production-schedule-item-in-path-group]',
  templateUrl: './production-schedule-item-in-path-group.component.html',
  styleUrls: ['./production-schedule-item-in-path-group.component.scss']
})
export class ProductionScheduleItemInPathGroupComponent extends BaseComponent implements OnChanges {
  @HostBinding('class.production-schedule-item-repetition') @Input() public isProductionScheduleItemInPathGroupRepetition: boolean;
  @Input() public productionScheduleItem: ProductionScheduleItemInPathGroup;
  @Input() public cutbarBeforeHeight: number;
  @Input() public cutbarAfterHeight: number;
  @Input() public drawingHeight: number;
  @Input() public drawingImageHeight: number;
  @Input() public drawingWidth: number;
  @Input() public totalHeight: number;

  public cutbarAfterVerticalPosition = 0;
  public drawingVerticalPosition = 0;

  public constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {
    super();
  }

  public ngOnChanges(): void {
    this.setCutbarAfterVerticalPosition();
    this.setProductionScheduleItemInPathGroupAttributes();
    this.drawingVerticalPosition = this.productionScheduleItem.isRecolored ? this.cutbarBeforeHeight : 0;
  }

  public getPlaceholderWidthAndHeight(): number {
    return this.productionScheduleItem.technicalDimensions.heightInPicks > this.productionScheduleItem.technicalDimensions.widthInDents ? this.drawingWidth : this.drawingImageHeight;
  }

  public getPlaceholderPosition(): string {
    const placeholderWidthAndHeight = this.getPlaceholderWidthAndHeight();
    const position = -placeholderWidthAndHeight / 2;

    return `translate(${position}, ${position})`;
  }

  private setProductionScheduleItemInPathGroupAttributes(): void {
    const productionScheduleItemInPathGroupElement = this.elementRef.nativeElement;

    this.renderer.setAttribute(productionScheduleItemInPathGroupElement, 'height', `${this.getProductionScheduleItemInPathGroupHeight()}`);
    this.renderer.setAttribute(productionScheduleItemInPathGroupElement, 'width', `${this.drawingWidth}`);
    this.renderer.setAttribute(productionScheduleItemInPathGroupElement, 'y', `${this.getVerticalPositionOfProductionScheduleItemInPathGroup()}`);
    this.renderer.setAttribute(productionScheduleItemInPathGroupElement, 'x', '0');
  }

  private getVerticalPositionOfProductionScheduleItemInPathGroup(): number {
    if (!isNil(this.elementRef.nativeElement) && this.isProductionScheduleItemInPathGroupRepetition) {
      return this.elementRef.nativeElement.previousElementSibling.getAttribute('y') - this.getProductionScheduleItemInPathGroupHeight();
    } else {
      return this.totalHeight - this.getProductionScheduleItemInPathGroupHeight();
    }
  }

  private setCutbarAfterVerticalPosition(): void {
    this.cutbarAfterVerticalPosition = this.drawingHeight + this.cutbarBeforeHeight;
  }

  private getProductionScheduleItemInPathGroupHeight(): number {
    return this.cutbarAfterHeight + this.cutbarBeforeHeight + this.drawingHeight;
  }
}
